import { render, staticRenderFns } from "./GroupLesson.vue?vue&type=template&id=180e3a62&scoped=true"
import script from "./GroupLesson.vue?vue&type=script&lang=js"
export * from "./GroupLesson.vue?vue&type=script&lang=js"
import style0 from "./GroupLesson.vue?vue&type=style&index=0&id=180e3a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e3a62",
  null
  
)

export default component.exports